import { Box, Table, Title } from '@factorialco/deprecated-design-system'
import {
  JournalEntryFragment,
  LegalEntityWithFinanceAccountsFragment,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { JournalEntryData } from './JournalEntryData'
import { JournalEntryLineRow } from './JournalEntryLineRow'
import { JournalLineFooter } from './JournalLineFooter'

interface Props {
  journalEntry?: JournalEntryFragment | null
  legalEntity?: LegalEntityWithFinanceAccountsFragment | null
  currency: string
}

export const JournalEntryTab = ({ journalEntry, legalEntity, currency }: Props) => {
  const { access } = useCurrentSession()
  const locale = access.locale

  return (
    <Box gap="s16" padding="s16">
      {journalEntry?.type && (
        <JournalEntryData
          journalEntry={journalEntry}
          currency={currency.toUpperCase()}
          legalEntityName={legalEntity?.legalName || ''}
          type={journalEntry?.type}
          disabled
          status={journalEntry?.status}
        />
      )}

      <Box paddingTop="s16">
        <Title
          variant="400"
          title={i18n.t('finance.journal_entry.title')}
          description={i18n.t('finance.journal_entry.description')}
        />
      </Box>
      <Table
        style={{ flex: '1', overflowY: 'auto', height: 'auto' }}
        optionsBottom={() => (
          <JournalLineFooter
            journalEntryLines={journalEntry?.journalLines || []}
            locale={locale}
            currency={currency}
            disabled
          />
        )}
        bottomSticky
        autoLayout
      >
        <Table.Head>
          <Table.Row>
            <Table.HeadCell paddingX="s4" ellipsis>
              <Box style={{ paddingLeft: '12px' }}>
                {i18n.t('finance.journal_entry.journal_line.header.account')}
              </Box>
            </Table.HeadCell>
            <Table.HeadCell paddingX="s24" ellipsis width={130}>
              <Box style={{ paddingRight: '20px' }}>
                {i18n.t('finance.journal_entry.journal_line.header.debit')}
              </Box>
            </Table.HeadCell>
            <Table.HeadCell paddingX="s24" ellipsis width={130}>
              <Box style={{ paddingRight: '20px' }}>
                {i18n.t('finance.journal_entry.journal_line.header.credit')}
              </Box>
            </Table.HeadCell>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {legalEntity &&
            journalEntry?.journalLines.map((journalEntryLine) => (
              <JournalEntryLineRow
                key={journalEntryLine.id}
                lineId={journalEntryLine.id}
                debitAmountCents={journalEntryLine.debitAmountCents || 0}
                creditAmountCents={journalEntryLine.creditAmountCents || 0}
                selectedLedgerAccount={journalEntryLine.account}
                currency={currency}
                locale={locale}
              />
            ))}
        </Table.Body>
      </Table>
    </Box>
  )
}
